import { render, staticRenderFns } from "./wxpaid.vue?vue&type=template&id=5f264ac4&"
import script from "./wxpaid.vue?vue&type=script&lang=js&"
export * from "./wxpaid.vue?vue&type=script&lang=js&"
import style0 from "./wxpaid.vue?vue&type=style&index=0&id=5f264ac4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports